// Generated by CoffeeScript 2.7.0
// ==============================================================================
// PROVIDERS - DETECT RESIZE
// ==============================================================================
import $ from "jquery";

$(function() {
  // Define Class
  this.detectResize = (function() {
    var _eventList, _isPc;

    class detectResize {
      // static public method
      static addFunction(platform, func, ...args) {
        return _eventList[platform].push({func, args});
      }

      static emitEvent() {
        var resizeQueue;
        clearTimeout(resizeQueue);
        return resizeQueue = window.setTimeout((function() {
          if (window.innerWidth < 768 && _isPc) {
            // SP
            _eventList.sp.forEach(function(e) {
              return e.func(...e.args);
            });
            return _isPc = false;
          } else if (window.innerWidth >= 768 && !_isPc) {
            // PC
            _eventList.pc.forEach(function(e) {
              return e.func(...e.args);
            });
            return _isPc = true;
          }
        }), 300);
      }

    };

    // static private parameters
    _isPc = false;

    _eventList = {
      pc: [],
      sp: []
    };

    return detectResize;

  }).call(this);
  // Window resize observer
  window.addEventListener('load', this.detectResize.emitEvent, false);
  return window.addEventListener('resize', this.detectResize.emitEvent, false);
});
